import { render, staticRenderFns } from "./kyc.vue?vue&type=template&id=66aff9e3&scoped=true&"
import script from "./kyc.vue?vue&type=script&lang=js&"
export * from "./kyc.vue?vue&type=script&lang=js&"
import style0 from "./kyc.vue?vue&type=style&index=0&id=66aff9e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aff9e3",
  null
  
)

/* custom blocks */
import block0 from "./kyc.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiTagline: require('/app/components/ui/tagline.vue').default,UiCtaLink: require('/app/components/ui/cta-link.vue').default,UiTransition: require('/app/components/ui/transition.vue').default,UiScrollContainer: require('/app/components/ui/scroll-container.vue').default,CaseSingleOverview: require('/app/components/case/single-overview.vue').default,FormsContact: require('/app/components/forms/contact.vue').default})
